import {changeDispositionsFilters, searchDispositions} from 'GenericTexting/ducks/disposition';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import Column from 'Shared/components/PagedView/Column';
import {withStringFilterProperties} from 'Shared/components/PagedView/Filter';
import {withValueChangedHook} from 'Shared/utilities/withValueChanged';
import './Dispositions.sass';
import ModularHost from 'Shared/components/ModularHost/ModularHost';
import ToolbarHeader from 'Shared/components/Toolbar/ToolbarHeader';
import PagedView from 'Shared/components/PagedView/PagedView';

const Dispositions = () => {
  const dispatch = useDispatch();
  const {filter, dispositionPage} = useSelector((state: ReducerState) => state.dispositions);

  const changeFilter = withValueChangedHook(filter, changeDispositionsFilters, dispatch);
  const filterProperties = {
    changeFilter,
    filterData: filter,
  };

  useEffect(() => {
    dispatch(searchDispositions(undefined, filter));
  }, [dispatch, filter]);

  return (
    <ModularHost>
      <ToolbarHeader title="Dispositions" />
      <PagedView
        pagedViewKey="dispositions"
        loadMore={page => dispatch(searchDispositions(page, filter))}
        data={dispositionPage}
      >
        {columnProps => (
          <>
            <Column
              {...columnProps}
              title="Phone Number"
              filterProperties={withStringFilterProperties(filterProperties, 'phoneNumber')}
              default
            >
              {disposition => disposition.phoneNumber}
            </Column>
            <Column
              {...columnProps}
              title="Short Code"
              filterProperties={withStringFilterProperties(filterProperties, 'shortCode')}
              default
            >
              {disposition => disposition.shortCode}
            </Column>
            <Column
              {...columnProps}
              title="Status"
              filterProperties={withStringFilterProperties(filterProperties, 'status')}
              default
            >
              {disposition => disposition.status}
            </Column>
          </>
        )}
      </PagedView>
    </ModularHost>
  );
};

export default Dispositions;
